"use strict";

var _objectSpread = require("/var/www/ivy-temp/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPOTLIGHT_TRENDING_RULE_DESCRIPTIONS = exports.SPOTLIGHT_TRENDING_RULE_LABELS = exports.MAX_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY = exports.MIN_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY = exports.DEFAULT_SPOTLIGHT_TRENDING_MIN_CHECKINS_PER_DAY = void 0;
exports.buildDefaultSpotlightTrendingConfig = buildDefaultSpotlightTrendingConfig;
exports.parseSpotlightTrending = parseSpotlightTrending;
exports.validateSpotlightTrendingForSave = validateSpotlightTrendingForSave;
exports.DEFAULT_SPOTLIGHT_TRENDING_MIN_CHECKINS_PER_DAY = 5;
exports.MIN_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY = 0;
exports.MAX_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY = 500;
exports.SPOTLIGHT_TRENDING_RULE_LABELS = {
  hotPlaces: 'Popular Today',
  checkinsPerDay: 'Check-ins per day',
  nearHotspot: 'Near a Hotspot'
};
exports.SPOTLIGHT_TRENDING_RULE_DESCRIPTIONS = {
  hotPlaces: 'Venue currently qualifies for the mobile "Popular Today" filter (at least one check-in today).',
  checkinsPerDay: 'Venue has at least N check-ins today (server timezone).',
  nearHotspot: 'Venue falls inside one of the live user-density Hotspots (Feature Flags → Hotspot config). Uses that ' + 'feature\'s own radius/user-count/active-window settings — nothing to configure here besides on/off.'
};
function buildDefaultSpotlightTrendingConfig() {
  return {
    rules: {
      hotPlaces: {
        enabled: true
      },
      checkinsPerDay: {
        enabled: true,
        minCount: exports.DEFAULT_SPOTLIGHT_TRENDING_MIN_CHECKINS_PER_DAY
      },
      nearHotspot: {
        enabled: true
      }
    }
  };
}
function parseFlagRule(raw, fallback) {
  if (!raw || typeof raw !== 'object') {
    return _objectSpread({}, fallback);
  }
  const value = raw;
  return {
    enabled: typeof value.enabled === 'boolean' ? value.enabled : fallback.enabled
  };
}
function parseCountRule(raw, fallback) {
  if (!raw || typeof raw !== 'object') {
    return _objectSpread({}, fallback);
  }
  const value = raw;
  return {
    enabled: typeof value.enabled === 'boolean' ? value.enabled : fallback.enabled,
    minCount: typeof value.minCount === 'number' && Number.isInteger(value.minCount) ? value.minCount : fallback.minCount
  };
}
function parseSpotlightTrending(raw) {
  const defaults = buildDefaultSpotlightTrendingConfig();
  if (!raw || typeof raw !== 'object') {
    return defaults;
  }
  const value = raw;
  const rulesRaw = value.rules && typeof value.rules === 'object' ? value.rules : {};
  return {
    rules: {
      hotPlaces: parseFlagRule(rulesRaw.hotPlaces, defaults.rules.hotPlaces),
      checkinsPerDay: parseCountRule(rulesRaw.checkinsPerDay, defaults.rules.checkinsPerDay),
      nearHotspot: parseFlagRule(rulesRaw.nearHotspot, defaults.rules.nearHotspot)
    }
  };
}
function validateSpotlightTrendingForSave(value) {
  if (!value || typeof value !== 'object') {
    return {
      message: 'spotlightTrending must be an object.'
    };
  }
  const config = value;
  if (!config.rules || typeof config.rules !== 'object') {
    return {
      message: 'spotlightTrending.rules must be an object.'
    };
  }
  const rules = config.rules;
  const hotPlacesRaw = rules.hotPlaces;
  if (!hotPlacesRaw || typeof hotPlacesRaw !== 'object' || typeof hotPlacesRaw.enabled !== 'boolean') {
    return {
      message: 'spotlightTrending.rules.hotPlaces.enabled must be a boolean.'
    };
  }
  const checkinsRaw = rules.checkinsPerDay;
  if (!checkinsRaw || typeof checkinsRaw !== 'object') {
    return {
      message: 'spotlightTrending.rules.checkinsPerDay must be an object.'
    };
  }
  const checkins = checkinsRaw;
  if (typeof checkins.enabled !== 'boolean') {
    return {
      message: 'spotlightTrending.rules.checkinsPerDay.enabled must be a boolean.'
    };
  }
  if (typeof checkins.minCount !== 'number' || !Number.isInteger(checkins.minCount)) {
    return {
      message: 'spotlightTrending.rules.checkinsPerDay.minCount must be an integer.'
    };
  }
  if (checkins.minCount < exports.MIN_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY || checkins.minCount > exports.MAX_SPOTLIGHT_TRENDING_CHECKINS_PER_DAY) {
    return {
      message: 'spotlightTrending.rules.checkinsPerDay.minCount is out of range.'
    };
  }
  const nearHotspotRaw = rules.nearHotspot;
  if (!nearHotspotRaw || typeof nearHotspotRaw !== 'object' || typeof nearHotspotRaw.enabled !== 'boolean') {
    return {
      message: 'spotlightTrending.rules.nearHotspot.enabled must be a boolean.'
    };
  }
  return null;
}
//# sourceMappingURL=spotlight-trending-config.js.map